// Example: Fetch inventory for variant by location
function fetchInventoryForVariant(variantId) {
  fetch(`/variants/${variantId}.json`)
    .then(response => response.json())
    .then(data => {
      const variant = data.variant;

      
      console.log("Hello, World!", variant);

      const inventoryByLocation = variant.inventory_quantity_by_location;

      let inventoryHtml = '';

      inventoryByLocation.forEach(location => {
        inventoryHtml += `<div>${location.name}: ${location.quantity}</div>`;
      });

      document.getElementById(`inventory-text-${variantId}`).innerHTML = inventoryHtml;
    })
    .catch(error => {
      console.error('Error fetching inventory:', error);
    });
}
